import { ThemeProvider } from '@mui/material/styles';
import React, { PropsWithChildren } from 'react';
import { defaultTheme } from 'src/theme/theme';

export const DefaultThemeProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>
);
